import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import {
  Link,
  redirect,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
// import "../../../style/Video1.css";
import "../style/Theme.css";
import PhaseLayout from "../../../phase1_6Layout/PhaseLayout";
import { AuthContext } from "../../../auth/AuthProvider";
import LoadingSpinner from "../../../loadingSpinner/LoadingSpinner.jsx";

export default function QuestionsP3() {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [theme, setTheme] = useState({});
  const [phase, setPhase] = useState({});
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [phase2, setPhase2] = useState([]);

  const [addedAnswer, setAddedAnswer] = useState();
  const [ansSelected, setAnsSelected] = useState();

  const {
    refreshTrigger,
    setRefreshTrigger,
    showQuestion,
    setShowQuestion,
    storage,
    authenticated,
    user,
    setLoading,
    loading,
    bgColor,
    setBgColor,
    payload,
    userProgress,
    setUserProgress,
    videoRef1,
    vidDuration,
    vidCurrTime,
    setVidCurrTime,
    setVidDuration,
    sessionId,
    googleUser,
    status,
    apiUrl,
  } = useContext(AuthContext);

  const navigate = useNavigate();

  const lastValidVidUrl = useRef(null);

  const { id, phaseTitle, hashed, answerLabel, phaseTitle1 } = useParams();

  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [themeProgress, setThemeProgress] = useState(0);

  useEffect(() => {
    // localStorage.setItem("location", location.pathname);

    axios
      .get(`${apiUrl}/theme/${id}`)
      .then((response) => {
        setTheme(response.data);
      })
      .catch((e) => {
        // console.error(e);
      });

    axios
      .get(`${apiUrl}/question/byPhase/${3}`)
      .then((response) => {
        setQuestions(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((e) => {
        // console.error(e);
      });

    axios
      .get(`${apiUrl}/answer`)
      .then((response) => {
        setAnswers(response.data.sort((a, b) => a.questionId - b.questionId));
      })
      .catch((e) => {
        // console.error(e);
      });

    axios
      .get(`${apiUrl}/phase/byTheme/${id}`)
      .then((response) => {
        setPhase2(response.data);
      })
      .catch((e) => {
        // console.error(e);
      });
  }, []);

  useEffect(() => {
    setSelectedAnswer(null);
    setShowQuestion(true);
  }, [hashed]);

  useEffect(() => {
    if (!user && !googleUser) {
      localStorage.setItem("postLoginRedirect", location.pathname);
      navigate("/login", { replace: true });
    }
  }, [user, googleUser, id, navigate]);

  useEffect(() => {
    if (!user && !googleUser) return;

    if (user) {
      const progress = {
        themeSlug: id,
        phaseName: phaseTitle,
        uuid: hashed,
        username: user.username,
      };

      axios.post(`${apiUrl}/user-progress/add`, progress).then((response) => {
        setUserProgress(response.data);
      });
    }

    if (googleUser) {
      const progress = {
        themeSlug: id,
        phaseName: phaseTitle,
        uuid: hashed,
        googleEmail: googleUser.email,
      };

      axios.post(`${apiUrl}/user-progress/add`, progress).then((response) => {
        setUserProgress(response.data);
      });
    }

    async function loadData() {
      try {
        if (!user && !googleUser) return;

        const identifier = user ? user.username : googleUser.email;

        const userEndpoint = user ? "byUserAndTheme" : "byGoogleUserAndTheme";
        const fullUserEndpoint = user ? "byUserInfo" : "byGoogleUserInfo";

        const latestQuestion = await axios.get(
          `${apiUrl}/user-question/${userEndpoint}/${identifier}/${id}`,
        );

        const sortedLatestQuestion = latestQuestion.data.sort(
          (a, b) => b.questionId - a.questionId,
        );

        const lastQuestion = await axios.get(
          `${apiUrl}/user-question/${fullUserEndpoint}/${identifier}/${id}/Phase 5`,
        );

        const completed = lastQuestion.data.some(
          (q) =>
            q.questionIndex === 5 &&
            q.phaseName === "Phase 5" &&
            q.questionNumber === "Question 5_5",
        );

        if (completed) {
          setThemeProgress(5);
          return;
        }

        setThemeProgress(sortedLatestQuestion[0]?.questionIndex);
      } catch (error) {}
    }

    loadData();
  }, [user, googleUser]);

  const currentQuestion = questions.find((q) => q.hashed === hashed);
  const answersForCurrentQuestion = answers.filter((a) => a.hashed === hashed);

  if (!currentQuestion)
    return (
      <LoadingSpinner
        customBg={"rgba(20, 13, 8, 0.92)"}
        customColor={"white"}
      />
    );
  function handleSubmit1(e) {
    e.preventDefault();
    setShowQuestion(false);

    if (!user && !googleUser) navigate("/login");

    if (user) {
      const answerData = {
        userUsername: user.username,
        questionId: selectedAnswer.questionId,
        answerLabel: selectedAnswer.label1,
        phaseId: selectedAnswer.phaseId,
        reflectionVideoUrl: selectedAnswer.vidUrl,
        themeSlug: id,
      };
      axios
        .post(`${apiUrl}/user-question/add`, answerData)
        .then((response) => {
          setRefreshTrigger(Date.now());

          setAddedAnswer(response.data);
          setAnsSelected(selectedAnswer.vidUrl);

          lastValidVidUrl.current = selectedAnswer.vidUrl;

          navigate(
            `/session/${id}/${phaseTitle}/${hashed}/${encodeURIComponent(selectedAnswer.label1)}`,
          );
        })
        .catch((err) => {});
    }

    if (googleUser) {
      const answerData = {
        googleEmail: googleUser.email,
        questionId: selectedAnswer.questionId,
        answerLabel: selectedAnswer.label1,
        phaseId: selectedAnswer.phaseId,
        reflectionVideoUrl: selectedAnswer.vidUrl,
        themeSlug: id,
      };
      axios
        .post(`${apiUrl}/user-question/add`, answerData)
        .then((response) => {
          setRefreshTrigger(Date.now());

          setAddedAnswer(response.data);
          setAnsSelected(selectedAnswer.vidUrl);

          lastValidVidUrl.current = selectedAnswer.vidUrl;

          navigate(
            `/session/${id}/${phaseTitle}/${hashed}/${encodeURIComponent(selectedAnswer.label1)}`,
          );
        })
        .catch((err) => {});
    }
  }

  return (
    <>
      <div
        className="question-container"
        style={{ backgroundColor: bgColor ? bgColor : "" }}
      >
        {/* <section> */}
        <div className="back-btn-div">
          <div>
            <Link to={`/session/${id}`} className="back-btn" id="back-btn">
              ❮
            </Link>
          </div>

          <section>
            <div>
              <p>{theme.title}</p>
            </div>
            <div>
              <h6>{phaseTitle}</h6>
              <h6>•</h6>
              <h6>Question {currentQuestion.questionNumber}/5</h6>
            </div>

            {/* <hr /> */}
          </section>

          <div className="hamburger-div">
            {!isOpen && (
              <button
                id="hamburger"
                className="hamburger"
                type="button"
                onClick={() => setIsOpen(true)}
                aria-label="Open menu"
                id="hamburger-question"
              >
                ☰
              </button>
            )}

            {isOpen && (
              <div
                className="sidebar-backdrop"
                onClick={() => setIsOpen(false)}
              />
            )}
          </div>
        </div>

        {/* <div style={{ color: "gray" }} className="phaseSectionParagraph psp">
          <div
            className="progressLineParent"
            id="progressLineParent"
            style={{
              // width: "14px",
              width: `${Math.floor(((themeProgress || 0) / 5) * 100)}%`,
            }}
          >
            <div className="progressLineChild" id="progressLineChild"></div>
          </div>
        </div> */}

        {/* </section> */}

        <section>
          <div key={hashed} className="feedback-container1">
            <h3>
              {phaseTitle} {phase2[2]?.name}
            </h3>

            <form onSubmit={handleSubmit1}>
              {answersForCurrentQuestion.map((a) => (
                <div key={a.id}>
                  <label className="labelAnswer">
                    <input
                      type="submit"
                      name={`q-${hashed}`}
                      value={a.label}
                      checked={selectedAnswer?.id === a.id}
                      onClick={() => {
                        if (selectedAnswer?.id === a.id) {
                          setSelectedAnswer(null);
                        } else {
                          setSelectedAnswer({
                            id: a.id,
                            vidUrl: a.reflectionVideoUrl,
                            label1: a.label,
                            questionId: a.questionId,
                            phaseId: a.phaseId,
                            phaseName: phaseTitle,
                            themeSlug: id,
                            uuid: hashed,
                          });
                          lastValidVidUrl.current = a.reflectionVideoUrl;
                        }
                      }}
                      // required
                    />
                    <span>{a.label}</span>
                  </label>
                  <br />
                </div>
              ))}

              {/* <button
                className="btnQuestion"
                type="submit"
                disabled={!selectedAnswer}
              >
                Submit
              </button> */}
            </form>
          </div>
        </section>
      </div>

      <div
        id="sidebarTheme"
        className={`sidebar ${isOpen ? "open" : "closed"}`}
      >
        <button
          id="closeBtn"
          className="close-btn"
          type="button"
          onClick={() => setIsOpen(false)}
          aria-label="Close menu"
        >
          X
        </button>

        <div className="plParent">
          <PhaseLayout />
        </div>
      </div>
    </>
  );
}
